import React from "react";
import {useSelector} from "react-redux";
import {getAppData} from "../../store/slices/appSlice";
import {useTranslation} from "react-i18next";
import CONST from "../../config/CONST";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import parseTotalServicesHtml from "../../helpers/parseTotalServicesHtml";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import GATracker, {GAEventBuildObject} from "../../helpers/GATracker";

const TotalServices = () => {

    const { t } = useTranslation();

    const appData = useSelector(getAppData);
    const financialProductConfiguration = useSelector(getFinancialConfiguration);

    if(!appData || !financialProductConfiguration) {
        return null;
    }

    const servicesArray = parseTotalServicesHtml(financialProductConfiguration['totalServices_'+appData.config.lang]);
    if(!servicesArray) {
        return null;
    }

    const ACCORDION_STATUS = {
        OPEN: 'open',
        CLOSE: 'close'
    }
    const accordionsStatus = [];
    for (let i = 0; i < servicesArray.length; i++) {
        accordionsStatus[i] = ACCORDION_STATUS.CLOSE;
    }

    const trackServiceAccordionEvent = (service, status) => {

        GATracker.trackEvent(GAEventBuildObject({
            event: {
                name: GATracker.EVENTS.SERVICE_ACCORDION.name.replace('{status}', status),
                category: GATracker.EVENTS.SERVICE_ACCORDION.category,
                action: GATracker.EVENTS.SERVICE_ACCORDION.action.replace('{status}', status),
                label: service.slug
            },
            appData: appData
        }))

    }

    const onAccordionClick = (service, i) => {
        accordionsStatus[i] = accordionsStatus[i] ===  ACCORDION_STATUS.OPEN ? ACCORDION_STATUS.CLOSE : ACCORDION_STATUS.OPEN;
        trackServiceAccordionEvent(service, accordionsStatus[i]);
    }

    return (
        <div className={`${CONST.CSS_NAMESPACE}TotalServices`}>
            <h2>{t(`TotalServices_${financialProductConfiguration?.productTypeCode}`)}</h2>
            <Accordion allowZeroExpanded>
                {servicesArray.map((service, i) => (
                    <AccordionItem key={service.id}>
                        <AccordionItemHeading
                            onClick={ () => onAccordionClick(service, i) }
                        >
                            <AccordionItemButton>
                                <h3 dangerouslySetInnerHTML={{__html: service.title}} />
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel dangerouslySetInnerHTML={{__html: service.body}}>
                        </AccordionItemPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}

export default TotalServices;